export const camposObrigatorios = {
  status: 'Status do Domínio',
  corText: 'Cor do Texto',
  corId: 'Cor do Background',
  nome: 'Nome do Domínio',
  descricao: 'Descrição do Domínio',
};

export const camposAjustar = {
  number: ['id', 'status', 'corId', 'corText'],
  string: ['nome', 'descricao', 'observacoes'],
};
